import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [

    //账户
    {
    	path: '/user',
    	name: '',
    	component: require('pages/user.vue').default,
    	children: [
        {
          path: '/',
          name: 'index',
          component: require('pages/user/index.vue').default,
        },
    		{
    			path: '/user1',
		    	name: 'user1',
		    	component: require('pages/user/user1.vue').default,
    		},
    		{
    			path: '/auth',
		    	name: 'auth',
		    	component: require('pages/user/auth.vue').default,
    		},
        {
          path: '/auth/personalAuth',
          name: 'personalAuth',
          component: require('pages/user/personalAuth.vue').default,
        },
        {
          path: '/auth/enterpriseAuth',
          name: 'enterpriseAuth',
          component: require('pages/user/enterpriseAuth.vue').default,
        },
        {
          path: '/auth/successAuth',
          name: 'successAuth',
          component: require('pages/user/successAuth.vue').default,
        },
        {
          path: '/oplog',
          name: 'oplog',
          component: require('pages/user/oplog.vue').default,
        },
    		{
    			path: '/user3',
		    	name: 'user3',
		    	component: require('pages/user/user3.vue').default,
    		},
    		{
    			path: '/user4',
		    	name: 'user4',
		    	component: require('pages/user/user4.vue').default,
    		},
    		{
    			path: '/user5',
		    	name: 'user5',
		    	component: require('pages/user/user5.vue').default,
    		},
        {
          path: '/weixin',
          name: 'weixin',
          component: require('pages/user/weixin.vue').default,
        },
    	]
    },
    //财务
    {
    	path: '/caiwu',
    	name: '',
    	component: require('pages/caiwu.vue').default,
      children: [
        {
          path: '/',
          name: 'caiwu1',
          component: require('pages/caiwu/caiwu2.vue').default,
        },
        {
          path: '/caiwu2',
          name: 'caiwu2',
          component: require('pages/caiwu/caiwu1.vue').default,
        },
        {
          path: '/caiwu3',
          name: 'caiwu3',
          component: require('pages/caiwu/caiwu3.vue').default,
        },
        {
          path: '/voucher',
          name: 'voucher',
          component: require('pages/caiwu/caiwu6.vue').default,
        },
        {
          path: '/caiwu4',
          name: 'caiwu4',
          component: require('pages/caiwu/caiwu4.vue').default,
        },
        {
          path: '/invoicelist',
          name: 'invoicelist',
          component: require('pages/caiwu/invoicelist.vue').default,
        },
        {
          path: '/invoiceinfo',
          name: 'invoiceinfo',
          component: require('pages/caiwu/invoiceinfo.vue').default,
        },
        {
          path: '/invoiceadd',
          name: 'invoiceadd',
          component: require('pages/caiwu/invoiceadd.vue').default,
        },
        {
          path: '/invoiceedit/:id',
          name: 'invoiceedit',
          component: require('pages/caiwu/invoiceedit.vue').default,
        },
        {
          path: '/client',
          name: 'client',
          component: require('pages/caiwu/client.vue').default,
        },
        {
          path: '/bill',
          name: 'bill',
          component: require('pages/caiwu/bill.vue').default,
        },
      ]
    },
    //产品
    {
      path: '/product',
      name: '',
      component: require('pages/product.vue').default,
      children: [
        {
          path: '/',
          name: 'freeVhostList',
          component: require('pages/product/freeVhostList.vue').default,
        },
        {
          path: '/freeVhost/:id',
          name: 'freeVhost',
          component: require('pages/product/freeVhost.vue').default,
        },
        {
          path: '/freeServerList',
          name: 'freeServerList',
          component: require('pages/product/freeServerList.vue').default,
        },
        {
          path: '/freeServer/:id',
          name: 'freeServer',
          component: require('pages/product/freeServer.vue').default,
        },
        {
          path: '/freeBeian',
          name: 'freeBeian',
          component: require('pages/product/freeBeian.vue').default,
        },
        {
          path: '/vhostDelay',
          name: 'vhostDelay',
          component: require('pages/product/vhostDelay.vue').default,
        },
        {
          path: '/domainMod',
          name: 'domainMod',
          component: require('pages/product/domainMod.vue').default,
        },
        {
          path: '/domainAddMod',
          name: 'domainAddMod',
          component: require('pages/product/domainAddMod.vue').default,
        },
        {
          path: '/domainEditMod/:name',
          name: 'domainEditMod',
          component: require('pages/product/domainEditMod.vue').default,
        },
        {
          path: '/vhostList',
          name: 'vhostList',
          component: require('pages/product/vhostList.vue').default,
        },
        {
          path: '/serverList',
          name: 'serverList',
          component: require('pages/product/serverList.vue').default,
        },
        {
          path: '/fuwu4',
          name: 'fuwu4',
          component: require('pages/fuwu/fuwu4.vue').default,
        },
        {
          path: '/fuwu5',
          name: 'fuwu5',
          component: require('pages/fuwu/fuwu5.vue').default,
        },
        {
          path: '/product7',
          name: 'product7',
          component: require('pages/product/product7.vue').default,
        },
        {
          path: '/domainout',
          name: 'domainout',
          component: require('pages/caiwu/master.vue').default,
        },
        {
          path: '/domainList',
          name: 'domainList',
          component: require('pages/product/domainList.vue').default,
        },
        {
          path: '/domain/:id',
          name: 'domain',
          component: require('pages/product/domain.vue').default,
        },
        {
          path: '/vhost/:id',
          name: 'vhost',
          component: require('pages/product/vhost.vue').default,
        },
        {
          path: '/server/:id',
          name: 'server',
          component: require('pages/product/server.vue').default,
        }
      ]
    },
    //服务
    {
      path: '/fuwu',
      name: '',
      component: require('pages/fuwu.vue').default,
      children: [
        {
          path: '/',
          name: 'fuwu1',
          component: require('pages/fuwu/fuwu1.vue').default,
        },
        {
          path: '/fuwu2',
          name: 'fuwu2',
          component: require('pages/fuwu/fuwu2.vue').default,
        },
        {
          path: '/fuwu3/:id',
          name: 'fuwu3',
          component: require('pages/fuwu/fuwu3.vue').default,
        },
      ]
    },
    //备案
    {
      path: '/beian',
      name: '',
      component: require('pages/beian.vue').default,
      children: [
        {
          path: '/',
          name: 'beian1',
          component: require('pages/beian/beian1.vue').default,
        },
        {
          path: '/icpMain',
          name: 'icpMain',
          component: require('pages/beian/icpMain.vue').default,
        },
        {
          path: '/beian3',
          name: 'beian3',
          component: require('pages/beian/beian3.vue').default,
        },
        {
          path: '/beian4',
          name: 'beian4',
          component: require('pages/beian/beian4.vue').default,
        },
        {
          path: '/icpContent/:id',
          name: 'icpContent',
          component: require('pages/beian/icpContent.vue').default,
        },
        {
          path: '/beian6',
          name: 'beian6',
          component: require('pages/beian/beian6.vue').default,
        },
        {
          path: '/beian7',
          name: 'beian7',
          component: require('pages/beian/beian7.vue').default,
        },
        {
          path: '/beian8',
          name: 'beian8',
          component: require('pages/beian/beian8.vue').default,
        },
        {
          path: '/beian9',
          name: 'beian9',
          component: require('pages/beian/beian9.vue').default,
        },
        {
          path: '/share',
          name: 'share',
          component: require('pages/beian/beian10.vue').default,
        },
      ]
    },
    //消息
    {
      path: '/message',
      name: 'message',
      component: require('pages/fuwu/message.vue').default,
    },
    {
      path: '/message/content/:id',
      name: 'msgcontent',
      component: require('pages/fuwu/content.vue').default,
    },
    { path: '*', redirect: '/user' },
  ]
})

/*router.beforeEach((to, from, next) => {
  if(!sessionStorage.getItem('user') && to.path === '/user'){
    window.location = "/login.html";
  }else{next()}
})*/
router.beforeEach((to, from, next) => {
  if(to.name === 'index'){
    sessionStorage.setItem('firstMenu','0')
    next()
  }
  if(to.path.indexOf('vhost') != -1){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','1')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  if(to.path.indexOf('server') != -1){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  if(to.name === 'domain'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','3')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //修改密码
  if(to.path === '/auth'){
    sessionStorage.setItem('firstMenu','0')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //实名认证
  if(to.path === '/auth'){
    sessionStorage.setItem('firstMenu','0')
    sessionStorage.setItem('secondMenu','3')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //绑定微信
  if(to.path === '/weixin'){
    sessionStorage.setItem('firstMenu','0')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','3')
    next()
  }
  //充值中心
  if(to.path === '/caiwu'){
    sessionStorage.setItem('firstMenu','1')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //财务明细
  if(to.path === '/caiwu2'){
    sessionStorage.setItem('firstMenu','1')
    sessionStorage.setItem('secondMenu','1')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //产品中心
  if(to.path === '/product'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //服务中心
  if(to.path === '/fuwu'){
    sessionStorage.setItem('firstMenu','3')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //网站备案
  if(to.path === '/beian'){
    sessionStorage.setItem('firstMenu','4')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //提交白名单
  if(to.path === '/fuwu4'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','1')
    next()
  }
  //添加域名模板
  if(to.path === '/domainAddMod'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','1')
    next()
  }
  //免费虚拟主机列表
  if(to.path === '/product'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //免费云服务器列表
  if(to.path === '/freeServerList'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','1')
    next()
  }
  //免备案列表
  if(to.path === '/freeBeian'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','0')
    sessionStorage.setItem('threeMenu','2')
    next()
  }
  //虚拟主机列表
  if(to.path === '/vhostList'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','1')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //云服务器列表
  if(to.path === '/serverList'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','2')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  //域名
  if(to.path === '/domainList'){
    sessionStorage.setItem('firstMenu','2')
    sessionStorage.setItem('secondMenu','3')
    sessionStorage.setItem('threeMenu','0')
    next()
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/router.js